import { DialogActions as MUIDialogActions } from '@mui/material';

interface DialogActionProps {
  children?: React.ReactNode;
}

/**
 * 공용 Dialog Action 영역 레이아웃
 *
 * @package
 */
export default function DialogActions({ children }: DialogActionProps) {
  return (
    <MUIDialogActions
      sx={theme => ({
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        padding: 2,
      })}
    >
      {children}
    </MUIDialogActions>
  );
}
